/**
 * Converts data into a human-readable error message format
 */
export const prettifyErrorData = (data: unknown): string => {
  if (typeof data === "string") {
    return data
  }

  if (typeof data === "number") {
    return data.toString()
  }

  if (Array.isArray(data)) {
    return prettifyArray(data)
  }

  if (typeof data === "object" && data !== null) {
    return prettifyObject(Object.entries(data))
  }

  return ""
}

const prettifyArray = (array: unknown[]): string => {
  const mapped = array.map(prettifyErrorData).filter(Boolean)

  if (mapped.length > 0) {
    return mapped.join(", ")
  }

  return ""
}

const prettifyObject = (entries: [string, unknown][]): string => {
  const validEntries = entries.filter(([, value]) => typeof value === "string")

  if (validEntries.length > 0) {
    return validEntries.map(([field, message]) => `Field "${field}": ${message}`).join(", ")
  }
  return ""
}
